import React from 'react'
import { IIconProps } from './inner/IIconProps'
import { IconICP } from 'main/common/components/icons/inner/IconICP'

/**
 * ICONE: abrir em uma nova aba
 */
export const OpenNewTabIconCP = (props: IIconProps): JSX.Element => {

    return (
        <IconICP
            iconName={'select'}
            size={props.size}
            color={props.color}
            style={props.style}
            theme={props.theme}
            transitionTime={props.transitionTime}
        />
    )
}
